import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0',
    },
    tableContainer: {
      paddingTop: theme.spacing(1),
      paddingLeft: 0,
      paddingRight: 0,
      overflowX: 'auto',
    },
    filterColTop: {
      width: '100%',
    },
    inputFocused: {
      backgroundColor: 'white !important',
    },
    menuPaper: {
      maxHeight: 300,
    },
    empty: {
      marginBottom: 20,
      marginTop: 20,
    },
    count: {
      fontStyle: 'bold',
      fontWeight: 600,
      color: '#000',
      marginRight: 15,
    },
    filterCol: {
      width: '100%',
      marginBottom: 24,
    },
    filter: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 5,
      padding: '28px 25px',
      overflow: 'visible',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '16px',
      },
    },
    label: {
      marginBottom: 7,
      fontSize: 16,
      fontWeight: 400,
      color: '#181c32',
    },
    title: {
      fontSize: 34,
      fontWeight: 'bold',
      color: '#000000',
      width: '30%',
      [theme.breakpoints.down('sm')]: {
        fontSize: 20,
        width: '100%',
        marginBottom: theme.spacing(2),
      },
    },
    rowFilter: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    ordersCol: {
      width: '100%',
    },
    orderColHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: 30,
    },
    orderColHeaderItem: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    filterItem: {
      transition: '0.3s ease-out',

      '&.hide': {
        [theme.breakpoints.down('sm')]: {
          height: 0,
          transform: 'scaleY(0)',
          transformOrigin: 'top',
          overflow: 'hidden',
        },
      },
    },
    buttons: {
      marginRight: theme.spacing(3),
      [theme.breakpoints.down(810)]: {
        marginRight: 0,
        marginBottom: theme.spacing(1),
      },
    },
    backButton: {
      backgroundColor: '#EBECF0 !important',
    },
    card: {
      marginBottom: theme.spacing(3),
      padding: 25,
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    bottomActions: {
      marginTop: theme.spacing(3),
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        width: '100%',
        '& > *': {
          width: '100%',
          marginLeft: '0 !important',
          marginRight: '0 !important',
        },
      },
    },
    img: {
      width: 50,
      objectFit: 'cover',
    },
    typeList: {
      backgroundColor: 'white',
      maxWidth: 200,
      fontSize: 16,
      fontWeight: 400,
      color: '#00070d',
      padding: 0,
      margin: 0,
    },
    itemStatus: {
      borderRadius: '4px',
      backgroundColor: '#c9f7f5',
      flex: 1,
    },
    viewButton: {
      marginRight: theme.spacing(2),
      color: theme.palette.primary.dark,
      textTransform: 'none',
      boxShadow: 'none',
      borderRadius: 2,
      padding: '10px 35px',
      fontWeight: 700,
      background: '#EBECF0',

      '&:hover': {
        boxShadow: 'none',
      },
    },
    iconViewButton: {
      marginLeft: 10,
    },
    companyField: {
      display: 'flex',
      alignItems: 'center',
    },
    allCompaniesBtn: {
      marginTop: 8,
      marginLeft: 10,
      height: 52,
    },
    input: {
      width: '100%',
      padding: '18px 14px',
      borderWidth: 0,
      borderRadius: 4,
      marginTop: 15,
      outline: 'none',
      boxSizing: 'border-box',
    },
    cell: {
      fontSize: 16,
      fontWeight: 400,
      color: '#181c32',
    },
    cellItem: {
      fontSize: 16,
      fontWeight: 400,
      color: '#00070d',
    },
    icon: {
      width: 22,
      height: 22,
    },
    subTableRow: {
      backgroundColor: '#a3a7b84c',
    },
    selects: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '60%',
      gap: 16,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        flexDirection: 'column',
        gap: theme.spacing(2),
      },
    },
    containerSelect: {
      width: '50%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    colorButton: {
      padding: '0 8px',
      textTransform: 'none',
      fontSize: 16,
      fontWeight: 400,
      color: '#00070d',
    },
    colorButtonIconView: {
      minWidth: 0,
      padding: 5,
      marginLeft: 8,
      marginBottom: 5,
    },
    containerPagination: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 16,
    },
    autoLoc: {
      width: '100%',
    },
    fieldsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',

      [theme.breakpoints.down(1024)]: {
        flexDirection: 'column',
      },
    },
    fields: {
      width: 'calc(50% - 12px)',
      [theme.breakpoints.down(1024)]: {
        width: '100%',
        maxWidth: 880,
      },
    },
    dates: {
      display: 'flex',
      flexDirection: 'column',
    },
    editorContainer: { width: '100%' },
    textField: {
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        maxWidth: '100%',
      },
    },
    fieldsWrapper: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: theme.spacing(1),
      },
    },
  };
});
